const EmailFooter = () => {

  return (
    <div>
      <h1>This is Email Footer</h1>
    </div>
  );
};

export default EmailFooter;